import { apiClient, handleResp } from './utils';

export default {
  getAccountInfo(accountId) {
    return handleResp(apiClient().get('/accounts/' + accountId), false);
  },
  doCheckout(data) {
    return handleResp(apiClient().post('/dashboard_checkout', data), false);
  },
  doIndividualCheckout(data) {
    return handleResp(apiClient().post('/individual_checkout', data), false);
  },
  doSendEBCOrder(copies) {
    return handleResp(apiClient().post('/order_ebc', { copies }), false);
  },
};
